import {createApp} from 'vue';
import StoreMap from './storeMap/StoreMap.vue';
import {stores} from '../stores/storeMap';

/**
 * @typedef {Object} Store
 * @property {string} id
 * @property {string} name
 * @property {string[]} services
 * @property {string} address
 * @property {string} postalCode
 * @property {string} city
 * @property {?string} phoneNumber
 * @property {Coordinates} coordinates
 * @property {?number} distance
 */
/**
 * @typedef {Object} Coordinates
 * @property {number} lat
 * @property {number} lng
 */

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('#store-list .store-list-map-container')
        .forEach(container => {
            stores.value = JSON.parse(container.dataset.stores);
            createApp(StoreMap).mount(container);
        });
});
